// extracted by mini-css-extract-plugin
module.exports = {"fb":"SocialAuth_fb__3bJlt"};